const initialState = {
  programmes: [],
  lots: [],
  deepSearch: [],
  deepSearchLoading: false,
  deepSearchError: null,
  lotsLoading: false,
  lotsError: null,
  lotsPagination: {
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  },
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  },
  activeOnglet: "stock",
  activeView: "lots",
  singleProgramId: null,
  singleProgram: null,
  singleProgramLoading: false,
  singleProgramError: null,
  openPrograms: [],
  openProgramsData: {},
  openProgramsLoading: {},
  openProgramsError: {},
  openLots: [],
  openLotsData: {},
  openLotsLoading: {},
  openLotsError: {},
  singleLotId: null,
  singleLot: null,
  singleLotLoading: false,
  singleLotError: null,
};

const immobilierReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ACTIVE_ONGLET":
      return {
        ...state,
        activeOnglet: action.payload,
      };

    case "SET_ACTIVE_VIEW":
      return {
        ...state,
        activeView: action.payload,
      };

    case "SET_SINGLE_PROGRAM_ID":
      return {
        ...state,
        singleProgramId: action.payload,
      };

    case "SET_SINGLE_LOT_ID":
      return {
        ...state,
        singleLotId: action.payload,
      };

    case "SET_CURRENT_PAGE":
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload,
        },
      };

    case "ADD_OPEN_PROGRAM":
      if (state.openPrograms.includes(action.payload)) {
        return state;
      }
      return {
        ...state,
        openPrograms: [...state.openPrograms, action.payload],
      };

    case "REMOVE_OPEN_PROGRAM":
      return {
        ...state,
        openPrograms: state.openPrograms.filter((id) => id !== action.payload),
      };

    case "ADD_OPEN_LOT":
      if (state.openLots.includes(action.payload)) {
        return state;
      }
      return {
        ...state,
        openLots: [...state.openLots, action.payload],
      };

    case "REMOVE_OPEN_LOT":
      return {
        ...state,
        openLots: state.openLots.filter((id) => id !== action.payload),
        openLotsData: {
          ...state.openLotsData,
          [action.payload]: undefined,
        },
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.payload]: undefined,
        },
        openLotsError: {
          ...state.openLotsError,
          [action.payload]: undefined,
        },
      };

    case "FETCH_PROGRAMMES_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FETCH_PROGRAMMES_SUCCESS":
      return {
        ...state,
        loading: false,
        programmes: action.payload.programmes,
        pagination: action.payload.pagination,
        error: null,
      };

    case "FETCH_PROGRAMMES_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "FETCH_SINGLE_PROGRAM_REQUEST":
      return {
        ...state,
        singleProgramLoading: true,
        singleProgramError: null,
      };

    case "FETCH_SINGLE_PROGRAM_SUCCESS":
      return {
        ...state,
        singleProgramLoading: false,
        singleProgram: action.payload,
        singleProgramError: null,
      };

    case "FETCH_SINGLE_PROGRAM_FAILURE":
      return {
        ...state,
        singleProgramLoading: false,
        singleProgramError: action.payload,
      };

    case "FETCH_SINGLE_LOT_REQUEST":
      return {
        ...state,
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.payload]: true,
        },
      };

    case "FETCH_SINGLE_LOT_SUCCESS":
      return {
        ...state,
        openLotsData: {
          ...state.openLotsData,
          [action.payload.id]: action.payload,
        },
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.payload.id]: false,
        },
        openLotsError: {
          ...state.openLotsError,
          [action.payload.id]: null,
        },
      };

    case "FETCH_SINGLE_LOT_FAILURE":
      return {
        ...state,
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.meta.documentId]: false,
        },
        openLotsError: {
          ...state.openLotsError,
          [action.meta.documentId]: action.payload,
        },
      };

    case "FETCH_LOTS_REQUEST":
      return {
        ...state,
        lotsLoading: true,
        lotsError: null,
      };

    case "FETCH_LOTS_SUCCESS":
      return {
        ...state,
        lotsLoading: false,
        lots: action.payload.lots,
        lotsPagination: action.payload.pagination,
        lotsError: null,
      };

    case "FETCH_LOTS_FAILURE":
      return {
        ...state,
        lotsLoading: false,
        lotsError: action.payload,
      };
    case "DEEP_SEARCH_LOADING":
      return {
        ...state,
        deepSearchLoading: true,
      };

    case "DEEP_SEARCH_SUCCESS":
      return {
        ...state,
        deepSearchLoading: false,
        deepSearch: action.payload,
        deepSearchError: null,
      };

    case "DEEP_SEARCH_FAILURE":
      return {
        ...state,
        deepSearchLoading: false,
        deepSearchError: action.payload,
      };
    case "CLOSE_SEARCH":
      return {
        ...state,
        deepSearch: [],
      };
    default:
      return state;
  }
};

export default immobilierReducer;
